export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33960.4068dcc9.jpg";